import React from 'react';
import { useTranslate } from 'react-admin';
import { DialogTitle, IconButton, makeStyles, Tooltip } from '@material-ui/core';
import { Close } from '@material-ui/icons';

import { Group } from '../../common/Flex';

const useStyles = makeStyles(theme => ({
  buttons: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
  }
}));

/**
 * DialogTitleWithAction is a React component that renders a dialog title
 * with a close button (by default) and optional additional actions.
 *
 * @param {Object} props - The props for the component.
 * @param {Function} [props.onClose] - Optional callback function to be called when the close button is clicked.
 * @param {React.ReactNode} props.children - The content to be displayed inside the dialog title.
 * @param {boolean} [props.hideClose] - If true, the close button will not be rendered.
 * @param {React.ReactNode[]} [props.actions] - Optional array of React elements to be rendered as additional actions.
 *
 * @returns {JSX.Element} The rendered dialog title with optional close button and actions.
 */
const DialogTitleWithActions = ({ onClose, children, hideClose = false, actions = [] }) => {
  const classes = useStyles();
  const translate = useTranslate();

  return (
    <>
      <DialogTitle>
        {children}
      </DialogTitle>
      <Group className={classes.buttons} gap={0}>
        {actions.map((action, index) => (
          <React.Fragment key={action.key || index}>{action}</React.Fragment>
        ))}
        {!hideClose && onClose && (
          <Tooltip title={translate('ra.action.close')}>
            <IconButton onClick={onClose}>
              <Close fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Group>
    </>
  );
};

export default DialogTitleWithActions;
